import React, { useRef } from 'react'

import styled from 'styled-components'
import { getTransition } from 'transitions/next-prev'

import { ReactFC } from 'types'

import { Link as RouterLink, useHistory, useRouteMatch } from "react-router-dom"


import { NavigationMessage } from 'navigation-ui/nav-bar'
import Tabs from '@material-ui/core/Tabs'

import Tab from '@material-ui/core/Tab'
import { useCircle } from 'circle/circle.selectors'
import AppBar from '@material-ui/core/AppBar'
import SwipeableViews from 'react-swipeable-views'
import { Badge, } from '@material-ui/core'
import { Circle } from 'circle/circle.types'
import { tabsStyle } from 'navigation-ui/tabsStyle'


export const getActiveTabIndex = tabs => {
  return tabs.findIndex(t => t.active)
}

export const getTertiaryTransition = (from, to) => {
  const fromIndex = getActiveTabIndex(from)
  const toIndex = getActiveTabIndex(to)
  return getTransition(fromIndex, toIndex)
}


export interface CircleTab {
  type: string
}

export const allTabs: CircleTab[] = [
  { "type": "groups/group/posts" },
  { "type": "groups/group/events" },
  { "type": "groups/group/activity" },
  { "type": "groups/group/outcome" },
  { "type": "groups/group/reference" },
  { "type": "groups/group/groups" }
]

interface TabPanelProps {
  index: any
  value: any
  component: React.ComponentType
  dir?: "rtl" | "ltr"
}

const TabPanelWrapper: ReactFC<{dir?: "rtl" | "ltr"}> = (props)=> {
  return (
    <div
      role="tabpanel"
      style={{direction: props.dir}}
      {...props}
    >
    </div>    
  )
}

const TabPanel: ReactFC<TabPanelProps> = (props) => {
  const current = useRef<any>(null)
  const { value, index, component: Component, ...other } = props
  if (!current.current && value === index) {
    current.current = <Component />
  }

  return <TabPanelWrapper {...other}>{current.current}</TabPanelWrapper>
}

const useChangeIndexHandler = (tabs: CircleTab[]) => {
  const circle = useCircle()
  const history = useHistory()
  return (index: number) => {
    const tab = tabs[index]
    const to = typeToUrl(tab.type, circle)
    history.push(to)
  }
}

const CircleTabsContainer = styled.div`
  && .MuiTab-root  {
    ${tabsStyle}
  }

  /* && .MuiIconButton-colorPrimary,  */
  .MuiIconButton-colorSecondary {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 1px 1px 4px #aaa;
    margin: 0 5px;
  }

  /* && .MuiIconButton-colorPrimary:hover,  */
  .MuiIconButton-colorSecondary:hover {
    background-color: #f9f9f9;
    width: 38px;
    height: 38px;
  }

  /* && .MuiIconButton-colorPrimary svg,  */
  /* .MuiIconButton-colorSecondary svg{
    margin: 0 5px;
  } */

  & h3 {
    margin-top: 5px;
  }
`

const CircleTabs = ({ tabFilter, component: Component, direction }) => {
  const tabs = tabFilter ? allTabs.filter(tabFilter) : allTabs
  const handleChangeIndex = useChangeIndexHandler(tabs)

  const value = activeTabIndex(tabs)
  const axis = direction === 'rtl' ? 'x-reverse' : 'x'

  return (
    <CircleTabsContainer>
      <TabsBar tabs={tabs} />
      <SwipeableViews
        key={axis}
        axis={axis}    
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {tabs.map((_, id) => <TabPanel key={id} value={value} index={id} component={Component} dir={direction} />)}
      </SwipeableViews>
    </CircleTabsContainer>
  )
}

const typeToUrl = (type: string, circle: Circle) => "/" + type.replace("/group/", `/${circle?._id}/`).replace("/posts", "")


export const TabLink: ReactFC<{ type: string }> = ({ type }) => {
  const circle = useCircle()
  const to = typeToUrl(type, circle)
  return (
    <RouterLink to={to}>
      <NavigationMessage id={type} />
    </RouterLink>
  )
}

export const CircleTab: ReactFC<{ type: string }> = ({ type, ...props }) => {
  const label1 = <TabLink type={type} />
  // const label = type.endsWith("posts") ? <PostsBadge>{label1}</PostsBadge> : label1
  return <Tab key={type} label={label1} {...props}/>
}

export const PostsBadge: ReactFC<{}> = ({ children }) => {
  const circle = useCircle()

  return (
    <Badge badgeContent={circle?.stats?.postCount} color="secondary">
      {children}
    </Badge>
  )
}

export const TabsBar: ReactFC<{ tabs: CircleTab[] }> = ({ tabs }) => {
  const value = activeTabIndex(tabs)

  return (
    <AppBar position="static">
      <Tabs
        value={value}
        variant="scrollable"
        aria-label="full width tabs example"
        data-testid="nav-bar">
        {tabs.map(t => <CircleTab key={t.type} type={t.type} data-intro={t.type}/>)}
      </Tabs>
    </AppBar>
  )
}

const activeTabIndex = (tabs: CircleTab[]) => {
  const match = useRouteMatch<any>("/groups/:group/:slug")
  if (!match) {
    return 0
  }
  const slug = match.params.slug
  const id = tabs.findIndex(t => t.type.endsWith(slug))
  return id === -1 ? 0 : id
}

export default CircleTabs



